import 'epic-games-nav/lib/epicGamesNav.epic-games-nav.css';
import 'epic-games-nav/lib/theme.odin.epic-games-nav.css';
import 'epic-games-footer/lib/epicGamesFooter.epic-games-footer.css';
import './common/boundBox.sass';
import './common/boxArtifact.sass';
import './common/expandingBlurb.sass';
import './common/video.sass';
import './sectionNav/sectionNav.sass';
import './sections/sections.sass';
import './sections/background/GradientBackground.sass';
import './sections/control/controlSection.sass';
import './sections/footer/footer.sass';
import './sections/mods/modSection.sass';
import './sections/reactions/reactionsSection.sass';
import './sections/recall/recallSection.sass';
import './sections/recall/scrollDown.sass';
import './sections/screenshot/screenshotSection.sass';
import './sections/story/storySection.sass';
import './sections/trailer/trailerSection.sass';
import './error/error.sass';
import '../../../styles/icons.sass';
